export default {"src":"/_next/static/media/international.76f1421c.svg","height":84,"width":84};